import { useTolgee } from '@tolgee/react'
import { AppLocale, DEFAULT_LOCALE } from '@kcm/contracts'

/**
 * The language the user is actually looking at, as a validated AppLocale.
 *
 * This is what must travel to the API — it becomes the session locale, and
 * through it the CRM `_locale` and Didit's hosted-flow `language` (§17). Sending
 * the site default instead would open KYC in the wrong language for anyone who
 * switched.
 */
export function useLocale(): AppLocale {
  const tolgee = useTolgee(['language'])
  const parsed = AppLocale.safeParse(tolgee.getLanguage())
  return parsed.success ? parsed.data : DEFAULT_LOCALE
}
